import { render, staticRenderFns } from "./TagInfoBox.vue?vue&type=template&id=503ba5e4&scoped=true&"
import script from "./TagInfoBox.vue?vue&type=script&lang=js&"
export * from "./TagInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./TagInfoBox.vue?vue&type=style&index=0&id=503ba5e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503ba5e4",
  null
  
)

export default component.exports